<app-popover-button [text]="'TABLE.columns' | translate" icon="playlist_add">
  <div class="grid">
    <div class="container">
      <h4>{{ 'TABLE.active_columns' | translate }}</h4>

      <div #activeList="cdkDropList"
        (cdkDropListDropped)="drop($event)"
        [cdkDropListConnectedTo]="[inactiveList]"
        [cdkDropListData]="activeColumns"
        cdkDropList
        class="list">
        @for (item of activeColumns; track item) {
          <div class="box" cdkDrag>
            <div class="label">
              <mat-icon>menu</mat-icon>
              {{ getLabel(item) }}
            </div>
          </div>
        }
      </div>
    </div>

    <div class="container">
      <h4>{{ 'TABLE.inactive_columns' | translate }}</h4>

      <div #inactiveList="cdkDropList"
        (cdkDropListDropped)="drop($event)"
        [cdkDropListConnectedTo]="[activeList]"
        [cdkDropListData]="inactiveColumns"
        cdkDropList
        class="list">
        @for (item of inactiveColumns; track item) {
          <div class="box" cdkDrag>
            <div class="label">
              <mat-icon>menu</mat-icon>
              {{ getLabel(item) }}
            </div>
          </div>
        }
      </div>
    </div>
  </div>
</app-popover-button>
